import { Field, Table, Pagination } from "@alifd/next";
import { BefRpcContext } from "@beflam/bef-core";

import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";

const SelectUsers = forwardRef((props: any, ref) => {
    const { selectedKeys, ...otherProps } = props;
    let [dataSource, setDataSource] = useState({ data: [] as any[], dataSource: [] as any[], currentPage: 1, selectedRowKeys: [], selectRecords: [] as any[], columnWidth: {} as any });
    const befRpc = useContext(BefRpcContext);
    const tabRef = useRef<any>(null);
    let contextComp: any = {};
    const pageSize = 8;
    const fieldRef = useRef(new Field(contextComp));

    const getUserList = async (current: any) => {
        const wheres: any[] = [{ field: 'State', control: 'notEqualTo', value: "DL" }];
        let res = await befRpc.callRpcAsync<any[]>("", "Beflam.Framework", "Beflam.Framework.Service.UserService", "List", { Wheres: wheres });
        let result = res.slice((current - 1) * pageSize, current * pageSize);
        let _selecteds = [] as any;
        if (selectedKeys && selectedKeys !== '') {
            _selecteds = selectedKeys.split(',');
        }
        setDataSourceEx({ ...dataSource, data: res, dataSource: result, currentPage: current, selectedRowKeys: _selecteds, selectRecords: [] });

    }
    useEffect(() => {
        getUserList(1);
        fieldRef.current.reset();
        fieldRef.current.setValues({ Ids: "" });
    }, []);
    useEffect(() => {

        tabRef.current = dataSource;
    }, [dataSource]);
    useImperativeHandle(ref, () => {
        let proxy: any = {};
        Object.defineProperty(proxy, 'dataSource', {
            get() {
                let result: any = tabRef.current;
                return result;
            }
        });
        return proxy;
    }, []);
    const setDataSourceEx = (data: any) => {
        dataSource = data;
        setDataSource(data);
    }
    const onPaginationChange = (current: number, e?: any) => {
        let result = dataSource.data.slice((current - 1) * pageSize, current * pageSize);
        setDataSourceEx({ ...dataSource, dataSource: result, currentPage: current });
    }
    return (
        <>
            <div className="bef-custom-dep" style={{ height: "470px", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                <div className=" margin-top-16 custom-table display-flex-col " style={{ height: '100%', overflow: "hidden" }}>
                    <Table style={{ height: 'calc(100% - 52px)' }} hasBorder={false} fixedHeader maxBodyHeight='348px' className=" bef-department-content" size='medium' primaryKey="UserId" dataSource={dataSource?.dataSource}
                        rowSelection={{ selectedRowKeys: dataSource.selectedRowKeys, onChange: (selectedKeys, records) => setDataSourceEx({ ...dataSource, selectedRowKeys: selectedKeys, selectRecords: records }) }}
                        onResizeChange={(dataIndex: string, value: number) => {

                        }}>
                        <Table.Column title="用户Id" dataIndex="UserId" />
                        <Table.Column title="用户名称" dataIndex="UserName" />
                    </Table>
                    <div className="display-flex justify-end margin-top-8 margin-bottom-8 margin-right-6">
                        <Pagination style={{ marginTop: '8px' }} className="margin-top-8" shape="no-border" pageSize={pageSize} total={dataSource.data.length} current={dataSource.currentPage} onChange={onPaginationChange} />
                    </div>
                </div>

            </div>
        </>
    );
});
export default SelectUsers;